import axios from "axios";
import { metadataUrl } from "config";
import { FancyBearMetadata } from "types";

export const fetchMetadata = async (
  tokenId: number
): Promise<FancyBearMetadata> => {
  const res = await axios.get<FancyBearMetadata>(`${tokenId}`, {
    baseURL: metadataUrl,
  });
  const traits = res.data.hash.split(".").map((trait) => parseInt(trait, 10));
  traits.shift();

  return {
    ...res.data,
    traits,
  };
};
